import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Image } from "react-bootstrap";
import { Box, FormControl, Typography, TextField, InputAdornment } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faMobileScreenButton, faUnlockKeyhole,  } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash, faEye } from "@fortawesome/free-regular-svg-icons";
import { faArrowRightToBracket, faUser } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import axios from 'axios'
 
const SignUp = () => {
  const [eyeToggle, setEyetoggle] = useState(true);
  const [eyeToggleConfirm, setEyetoggleConfirm] = useState(true);
   
 
  const [signupForm, setSignupForm] = useState({
    userName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: ""
  });
 
  const [errors, setErrors] = useState({});
 
  // Toggle password visibility
  const passwordToggler = () => {
    setEyetoggle(!eyeToggle);
  };
  const passwordTogglerConfirm = () => {
    setEyetoggleConfirm(!eyeToggleConfirm);
  };
  // Handle Input Change & Validate in Real-time
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignupForm({ ...signupForm, [name]: value });
 
    // Validate immediately after user input
    validateField(name, value);
  };
 
  // Field-wise validation for real-time error clearing
  const validateField = (name, value) => {
    let tempErrors = { ...errors };
 
    switch (name) {
      case "userName":
        tempErrors.userName = value ? "" : "Username is required";
        break;
 
        case "email":
          const emailRegex = /^[^\s@]+@[^\s@]+\.(com|org|in)$/;
          tempErrors.email = emailRegex.test(value) ? "" : "Valid email required (e.g., name@example.com)";
          break;
 
      case "phone":
        tempErrors.phone = /^\d{10}$/.test(value) ? "" : "Phone number must be 10 digits";
        break;
 
      case "password":
        tempErrors.password = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/.test(value)
          ? ""
          : "Password must be 8+ chars, include letters & numbers";
        break;
 
      case "confirmPassword":
        tempErrors.confirmPassword = value === signupForm.password ? "" : "Passwords do not match";
        break;
 
      default:
        break;
    }
 
    setErrors(tempErrors);
  };
 
  // Full form validation before submission
  const validateForm = () => {
    let tempErrors = {};
    // Validate all fields
    Object.keys(signupForm).forEach((key) => {
      validateField(key, signupForm[key]);
      if (!signupForm[key]) tempErrors[key] = `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
    });
 
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }
  // Handle Form Submission
  const signUpSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
 
    try {
      const response = await axios.post("http://localhost:5000/api/auth/register", {
        username: signupForm.userName,
        email: signupForm.email,
        phone: signupForm.phone,
        password: signupForm.password,
         headers: {
                'Content-Type': 'application/json',
            },
      });
      // clear the form after user success sign up
      setSignupForm({ userName: "", email: "", phone: "", password: "", confirmPassword: "" });
 
      console.log("Signup Successful:", response.data);
      alert("User registered successfully!");
    } catch (error) {
      console.error("Signup Error:", error.response?.data || error.message);
      alert(error.response?.data?.message || "Signup failed!");
    }
  };
  
    const handleGoogleSignIn = () => {
      window.location.href = "http://localhost:5000/auth/google";
    };
  return (
    <>
      <Box className="loginContainer" style={{ zIndex: "2", position: "relative" }}>
        <Box className="dividerBox">
          <Box className="form">
            <Container>
              <Row>
                <Col lg="12">
                  <motion.div className="loginMotion">
                    <Form className="loginform">
                      <Typography variant="body1" component="p">
                        Welcome
                      </Typography>
                      <Typography variant="h2">Sign Up</Typography>
 
                      {/* Name Field */}
                      <FormControl fullWidth>
                        <Typography variant="body1" component="label">
                          Name
                        </Typography>
                        <TextField
                          className="authInput"
                          label="Name"
                          name=""
                          value={signupForm.userName}
                          onChange={handleChange}
                          placeholder="Enter Your Name"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FontAwesomeIcon icon={faUser} />
                              </InputAdornment>
                            ),
                          }}
                          error={!!errors.userName}
                          helperText={errors.userName}
                        />
                      </FormControl>
 
                      {/* Email Field */}
                      <FormControl fullWidth>
                        <Typography variant="body1" component="label">
                          Email
                        </Typography>
                        <TextField
                          className="authInput"
                          label="Email"
                          name="email"
                          value={signupForm.email}
                          onChange={handleChange}
                          placeholder="Enter Your Email"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FontAwesomeIcon icon={faAt} />
                              </InputAdornment>
                            ),
                          }}
                          error={!!errors.email}
                          helperText={errors.email}
                        />
                      </FormControl>
 
                      {/* Phone Field */}
                      <FormControl fullWidth>
                        <Typography variant="body1" component="label">
                          Phone Number
                        </Typography>
                        <TextField
                          className="authInput"
                          label="Phone"
                          name="phone"
                          value={signupForm.phone}
                          onChange={handleChange}
                          placeholder="Enter Your Phone Number"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FontAwesomeIcon icon={faMobileScreenButton} />
                              </InputAdornment>
                            ),
                          }}
                          error={!!errors.phone}
                          helperText={errors.phone}
                        />
                      </FormControl>
 
                      {/* Password Field */}
                      <FormControl fullWidth>
                        <Typography variant="body1" component="label">
                          Password
                        </Typography>
                        <TextField
                          type={eyeToggle ? "password" : "text"}
                          className="authInput"
                          label="Password"
                          name="password"
                          value={signupForm.password}
                          onChange={handleChange}
                          placeholder="Enter Your Password"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FontAwesomeIcon icon={faUnlockKeyhole} />
                              </InputAdornment>
                            ),
                          }}
                          error={!!errors.password}
                          helperText={errors.password}
                        />
                        <FontAwesomeIcon className="passEye" icon={eyeToggle ? faEyeSlash : faEye} onClick={passwordToggler} />
                      </FormControl>
 
                      {/* Confirm Password Field */}
                      <FormControl fullWidth>
                        <Typography variant="body1" component="label">
                          Confirm Password
                        </Typography>
                        <TextField
                          type={eyeToggleConfirm ? "password" : "text"}
                          className="authInput relative"
                          label="Confirm Password"
                          name="confirmPassword"
                          value={signupForm.confirmPassword}
                          onChange={handleChange}
                          placeholder="Confirm Your Password"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FontAwesomeIcon icon={faUnlockKeyhole} />
                              </InputAdornment>
                            ),
                          }}
                          error={!!errors.confirmPassword}
                          helperText={errors.confirmPassword}
                        />
                        <FontAwesomeIcon className="passEye" icon={eyeToggleConfirm ? faEyeSlash : faEye} onClick={passwordTogglerConfirm} />
                      </FormControl>
 
                      {/* Submit Button */}
                      <Box className="btnWrapper text-end">
                        <Button style={{opacity:'0.8', cursor:'not-allowed', pointerEvents:'none'}} variant="link" className="coverBtn btnIcon authBtn my-3" onClick={signUpSubmit}>
                          <span>
                            Sign up <FontAwesomeIcon icon={faArrowRightToBracket} />
                          </span>
                        </Button>
                      </Box>
                      <Box className="orDivider">
                         <Typography variant="body1" component="span">OR</Typography>
                       </Box>
                       <Box className="googleLogin">
                         <Button  onClick={handleGoogleSignIn}  className="btn-link imgBtn w-100 my-3" >  <Image className="img-fluid" src="https://cdn-icons-png.flaticon.com/128/281/281764.png"></Image> Continue with Google</Button>
                       </Box>
                    </Form>
                  </motion.div>
                </Col>
              </Row>
            </Container>
          </Box>
        </Box>
      </Box>
    </>
  );
};
 
export default SignUp;